var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgHiddenCost = function SvgHiddenCost(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 32.25,
    y1: 30.011311,
    x2: 32.25,
    y2: 45.6875,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(96.862745%,97.647059%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 32.25,
    y1: 77.9375,
    x2: 32.25,
    y2: 92.71875,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(96.862745%,97.647059%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 32.25,
    y1: 125.863693,
    x2: 32.25,
    y2: 142.461685,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(96.862745%,97.647059%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(58.431375%,71.764708%,100%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 84.822884,
    y1: 19.261311,
    x2: 84.822884,
    y2: 155.014999,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(52.941179%,63.529414%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 32.25,
    y1: 19.261311,
    x2: 32.25,
    y2: 155.014999,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(52.941179%,63.529414%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 95.572884,
    y1: 19.261311,
    x2: 95.572884,
    y2: 155.014999,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(52.941179%,63.529414%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear6",
    gradientUnits: "userSpaceOnUse",
    x1: 32.25,
    y1: 19.261311,
    x2: 32.25,
    y2: 155.014999,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(52.941179%,63.529414%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear7",
    gradientUnits: "userSpaceOnUse",
    x1: 106.322884,
    y1: 19.261311,
    x2: 106.322884,
    y2: 155.014999,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(52.941179%,63.529414%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear8",
    gradientUnits: "userSpaceOnUse",
    x1: 32.25,
    y1: 19.261311,
    x2: 32.25,
    y2: 155.014999,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(52.941179%,63.529414%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(14.509805%,42.745098%,99.607843%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface2809900"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 9.375 9.375 C 8.511719 9.375 7.8125 10.074219 7.8125 10.9375 C 7.8125 11.800781 8.511719 12.5 9.375 12.5 C 10.238281 12.5 10.9375 11.800781 10.9375 10.9375 C 10.9375 10.074219 10.238281 9.375 9.375 9.375 Z M 9.375 9.375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 9.375 23.4375 C 8.511719 23.4375 7.8125 24.136719 7.8125 25 C 7.8125 25.863281 8.511719 26.5625 9.375 26.5625 C 10.238281 26.5625 10.9375 25.863281 10.9375 25 C 10.9375 24.136719 10.238281 23.4375 9.375 23.4375 Z M 9.375 23.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 9.375 37.5 C 8.511719 37.5 7.8125 38.199219 7.8125 39.0625 C 7.8125 39.925781 8.511719 40.625 9.375 40.625 C 10.238281 40.625 10.9375 39.925781 10.9375 39.0625 C 10.9375 38.199219 10.238281 37.5 9.375 37.5 Z M 9.375 37.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 20.15625 15.082031 C 20.578125 15.429688 21.113281 15.625 21.660156 15.625 L 30.46875 15.625 C 31.761719 15.625 32.8125 14.574219 32.8125 13.28125 L 32.8125 8.59375 C 32.8125 7.300781 31.761719 6.25 30.46875 6.25 L 21.660156 6.25 C 21.113281 6.25 20.578125 6.445312 20.160156 6.792969 L 17.347656 9.136719 C 16.8125 9.582031 16.503906 10.238281 16.503906 10.9375 C 16.503906 11.636719 16.8125 12.292969 17.347656 12.738281 Z M 31.25 8.59375 L 31.25 13.28125 C 31.25 13.710938 30.898438 14.0625 30.46875 14.0625 L 29.542969 14.0625 C 29.632812 13.816406 29.6875 13.554688 29.6875 13.28125 L 29.6875 8.59375 C 29.6875 8.320312 29.632812 8.058594 29.542969 7.8125 L 30.46875 7.8125 C 30.898438 7.8125 31.25 8.164062 31.25 8.59375 Z M 18.347656 10.335938 L 21.160156 7.992188 C 21.300781 7.878906 21.476562 7.8125 21.660156 7.8125 L 27.34375 7.8125 C 27.773438 7.8125 28.125 8.164062 28.125 8.59375 L 28.125 13.28125 C 28.125 13.710938 27.773438 14.0625 27.34375 14.0625 L 21.660156 14.0625 C 21.476562 14.0625 21.300781 13.996094 21.160156 13.882812 L 18.347656 11.539062 C 18.101562 11.335938 18.066406 11.074219 18.066406 10.9375 C 18.066406 10.800781 18.101562 10.539062 18.347656 10.335938 Z M 18.347656 10.335938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear4)"
    },
    d: "M 9.375 6.25 C 6.789062 6.25 4.6875 8.351562 4.6875 10.9375 C 4.6875 13.523438 6.789062 15.625 9.375 15.625 C 11.960938 15.625 14.0625 13.523438 14.0625 10.9375 C 14.0625 8.351562 11.960938 6.25 9.375 6.25 Z M 9.375 14.0625 C 7.652344 14.0625 6.25 12.660156 6.25 10.9375 C 6.25 9.214844 7.652344 7.8125 9.375 7.8125 C 11.097656 7.8125 12.5 9.214844 12.5 10.9375 C 12.5 12.660156 11.097656 14.0625 9.375 14.0625 Z M 9.375 14.0625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear5)"
    },
    d: "M 20.15625 29.144531 C 20.578125 29.492188 21.113281 29.6875 21.660156 29.6875 L 36.71875 29.6875 C 38.011719 29.6875 39.0625 28.636719 39.0625 27.34375 L 39.0625 22.65625 C 39.0625 21.363281 38.011719 20.3125 36.71875 20.3125 L 21.660156 20.3125 C 21.113281 20.3125 20.578125 20.507812 20.160156 20.855469 L 17.347656 23.199219 C 16.8125 23.644531 16.503906 24.300781 16.503906 25 C 16.503906 25.699219 16.8125 26.355469 17.347656 26.800781 Z M 37.5 22.65625 L 37.5 27.34375 C 37.5 27.773438 37.148438 28.125 36.71875 28.125 L 35.792969 28.125 C 35.882812 27.878906 35.9375 27.617188 35.9375 27.34375 L 35.9375 22.65625 C 35.9375 22.382812 35.882812 22.121094 35.792969 21.875 L 36.71875 21.875 C 37.148438 21.875 37.5 22.226562 37.5 22.65625 Z M 18.347656 24.398438 L 21.160156 22.054688 C 21.300781 21.941406 21.476562 21.875 21.660156 21.875 L 33.59375 21.875 C 34.023438 21.875 34.375 22.226562 34.375 22.65625 L 34.375 27.34375 C 34.375 27.773438 34.023438 28.125 33.59375 28.125 L 21.660156 28.125 C 21.476562 28.125 21.300781 28.058594 21.160156 27.945312 L 18.347656 25.601562 C 18.101562 25.398438 18.066406 25.136719 18.066406 25 C 18.066406 24.863281 18.101562 24.601562 18.347656 24.398438 Z M 18.347656 24.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear6)"
    },
    d: "M 9.375 20.3125 C 6.789062 20.3125 4.6875 22.414062 4.6875 25 C 4.6875 27.585938 6.789062 29.6875 9.375 29.6875 C 11.960938 29.6875 14.0625 27.585938 14.0625 25 C 14.0625 22.414062 11.960938 20.3125 9.375 20.3125 Z M 9.375 28.125 C 7.652344 28.125 6.25 26.722656 6.25 25 C 6.25 23.277344 7.652344 21.875 9.375 21.875 C 11.097656 21.875 12.5 23.277344 12.5 25 C 12.5 26.722656 11.097656 28.125 9.375 28.125 Z M 9.375 28.125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear7)"
    },
    d: "M 42.96875 34.375 L 21.660156 34.375 C 21.113281 34.375 20.578125 34.570312 20.160156 34.917969 L 17.347656 37.261719 C 16.8125 37.707031 16.503906 38.363281 16.503906 39.0625 C 16.503906 39.761719 16.8125 40.417969 17.347656 40.863281 L 20.15625 43.207031 C 20.578125 43.554688 21.113281 43.75 21.660156 43.75 L 42.96875 43.75 C 44.261719 43.75 45.3125 42.699219 45.3125 41.40625 L 45.3125 36.71875 C 45.3125 35.425781 44.261719 34.375 42.96875 34.375 Z M 21.660156 42.1875 C 21.476562 42.1875 21.300781 42.121094 21.160156 42.007812 L 18.347656 39.664062 C 18.101562 39.460938 18.066406 39.199219 18.066406 39.0625 C 18.066406 38.925781 18.101562 38.664062 18.347656 38.460938 L 21.160156 36.117188 C 21.300781 36.003906 21.476562 35.9375 21.660156 35.9375 L 39.84375 35.9375 C 40.273438 35.9375 40.625 36.289062 40.625 36.71875 L 40.625 41.40625 C 40.625 41.835938 40.273438 42.1875 39.84375 42.1875 Z M 43.75 41.40625 C 43.75 41.835938 43.398438 42.1875 42.96875 42.1875 L 42.042969 42.1875 C 42.132812 41.941406 42.1875 41.679688 42.1875 41.40625 L 42.1875 36.71875 C 42.1875 36.445312 42.132812 36.183594 42.042969 35.9375 L 42.96875 35.9375 C 43.398438 35.9375 43.75 36.289062 43.75 36.71875 Z M 43.75 41.40625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear8)"
    },
    d: "M 9.375 34.375 C 6.789062 34.375 4.6875 36.476562 4.6875 39.0625 C 4.6875 41.648438 6.789062 43.75 9.375 43.75 C 11.960938 43.75 14.0625 41.648438 14.0625 39.0625 C 14.0625 36.476562 11.960938 34.375 9.375 34.375 Z M 9.375 42.1875 C 7.652344 42.1875 6.25 40.785156 6.25 39.0625 C 6.25 37.339844 7.652344 35.9375 9.375 35.9375 C 11.097656 35.9375 12.5 37.339844 12.5 39.0625 C 12.5 40.785156 11.097656 42.1875 9.375 42.1875 Z M 9.375 42.1875 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHiddenCost, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hidden-cost.a01c466f.svg";
export { ForwardRef as ReactComponent };